import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestLicenseRetry = {
    path: "/plugin-update/:slug/license/:blogId/retry",
    method: RouteHttpVerb.POST
};
